import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "./helpers/constant";
import "./helpers/axios";
import "./helpers/bootstrap";
import "./filters/stripHtml";
import "./directives/scroll";
import "./tools/sentry";

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
